import { generateRowsData } from "./generateSpaceRowsData";
import { columns } from "./spaceColumns";

export const generateSpaceTableData = (rawData) => {
    var rowsData = generateRowsData(rawData)
    return {rows: rowsData, columns: columns }
}